export {};
//# sourceMappingURL=ITelemetryInitializers.js.map